import { render, staticRenderFns } from "./attentionList.vue?vue&type=template&id=dfe5d484&scoped=true&"
import script from "./attentionList.ts?vue&type=script&lang=ts&"
export * from "./attentionList.ts?vue&type=script&lang=ts&"
import style0 from "./attentionList.vue?vue&type=style&index=0&id=dfe5d484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe5d484",
  null
  
)

export default component.exports